import { AgroCard, Text } from "agrofy-ui-components";
import React, { useEffect, useState } from "react";
import { useStore } from "../../../hooks/store";
import { TrackPaymentMethodClick } from "../../../services/gtmEvents";
import IconButton from "../../Button/IconButton";
import "./MenuItem.scss";

const MenuItem = (props) => {
  const [state, dispatch] = useStore();
  const [selected, setSelected] = useState(false);
  
  const onSelectPaymentMethod = () => {
    setSelected(true);
    dispatch("SET_SELECTED_PAYMENT_CATEGORY", props.category);
    dispatch("SET_SELECTED_PAYMENT_METHOD", props.item);
    window.scrollTo(0, 0);
    TrackPaymentMethodClick(props.item.Name);
  };

  useEffect(() => {
    setSelected(
      state.selectedPaymentMethodType &&
      state.selectedPaymentMethodType.PaymentMethodTypeId ===
      props.item.PaymentMethodTypeId
    );
  }, [state.selectedPaymentMethodType]);

  const mobileItem = (
    <div className="d-mobile">
      <AgroCard className="cardPayment">
        <div onClick={onSelectPaymentMethod} className="cardContent">
          {props.item.Image && props.item.Image.length > 0 ? (
            <img style={{width: '20px', height: '20px'}} src={props.item.Image[0]} />      
          ) : null}
          <Text type="label-md" color="gray8" align="center" tag="h2" className={"m-0"}>
            {props.item.Name}
          </Text>
        </div>
      </AgroCard>
    </div>
  );

  const desktopItem = (
    <div className="menuItem d-desktop" onClick={onSelectPaymentMethod}>
      <IconButton
        text={props.item.Name}
        backColor={selected ? "#E8F1D9" : "transparent"}
        fontColor={selected ? "#224D00" : "gray8"}
        fontWeigth={selected ? "500" : "400"}
        icon={props.item.Image[0]}
      />
    </div>
  );

  return (
    <>
      {mobileItem}
      {desktopItem}
    </>
  );
};

export default MenuItem;
